import { isServer } from '@mr-yum/frontend-core/dist/support/env'
import {
  OrderingType,
  useRefreshCartPricesMutation,
  useSwiftPosMemberLoggedInCheckQuery,
} from 'lib/gql'
import { OrderingTypeSlug } from 'lib/routes'
import { useEffect } from 'react'

export const isMembershipDisabled = (posIntegrationType?: string | null) => {
  if (!posIntegrationType) {
    return true
  }

  return posIntegrationType !== 'AkrnSHd759Xa2XFWWf8gmBfDyoUmbWeVgRqHU6xxzsA='
}

interface Props {
  venueSlug: string
  orderingTypeSlug: OrderingTypeSlug
  orderingType: OrderingType
  posIntegrationType?: string | null
}

export const useIntegrationCheck = ({
  venueSlug,
  posIntegrationType,
  orderingType,
}: Props) => {
  const membershipIsDisabled = isMembershipDisabled(posIntegrationType)

  const [{ data: swiftPosMemberData, error: swiftPosMemberCheckError }] =
    useSwiftPosMemberLoggedInCheckQuery({
      variables: {
        venueSlug,
      },
      pause: isServer || membershipIsDisabled,
      requestPolicy: 'network-only',
    })

  const [{ error: refreshCartError }, refreshCartPrices] =
    useRefreshCartPricesMutation()

  useEffect(() => {
    async function refreshMemberCart() {
      if (swiftPosMemberData?.swiftPosMemberLoggedInCheckV2) {
        await refreshCartPrices({
          input: {
            venueSlug,
            orderingType,
          },
        })
      }
    }

    refreshMemberCart()
  }, [
    swiftPosMemberData?.swiftPosMemberLoggedInCheckV2,
    venueSlug,
    orderingType,
    refreshCartPrices,
  ])

  if (swiftPosMemberCheckError) {
    return {
      error: swiftPosMemberCheckError,
      isMemberLoggedIn: false,
      isMemberCartRefresh: false,
    }
  }

  if (refreshCartError) {
    return {
      error: refreshCartError,
      isMemberLoggedIn: swiftPosMemberData?.swiftPosMemberLoggedInCheckV2,
      isMemberCartRefresh: false,
    }
  }

  return {
    isMemberCartRefresh: swiftPosMemberData?.swiftPosMemberLoggedInCheckV2,
    isMemberLoggedIn: swiftPosMemberData?.swiftPosMemberLoggedInCheckV2,
  }
}
